export const ACTIVITY_CONFIG = {
  ACTIVE: {
    text: "ACTIVE",
    className: "active",
  },
  INACTIVE: {
    text: "INACTIVE",
    className: "inactive",
  },
};

export const STATUS_CONFIG = {
  "OUT OF DATE": {
    text: "OUT OF DATE",
    className: "badge error",
  },
  UPDATING: {
    text: "UPDATING",
    className: "badge",
  },
  "UP TO DATE": {
    text: "UP TO DATE",
    className: "badge success",
  },
};
